import axios from "axios";

export const listGalleryImages = () => axios.get("/api/gallery").then((r) => r.data);

export const uploadGalleryImage = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post("/api/gallery/upload", formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

export const addGalleryImage = (payload) => axios.post("/api/gallery", payload).then((r) => r.data);

export const deleteGalleryImage = (id) => axios.delete(`/api/gallery/${id}`).then((r) => r.data);

export const reorderGalleryImages = (orderedIds) =>
  axios.post("/api/gallery/reorder", { ordered_ids: orderedIds }).then((r) => r.data);
